const baseUrl = "https://app.redchilli.ai/";

const endPointUrl = baseUrl + "api/";

const STRIPE_PK = "pk_test_51OJxDrSHsfsONNwpIdzqG0ac5wy2HRGetmxsda5u3FVd50KZmKcK4LVCLYfFQOT4LmVzxcGmWwlYyairHgUVD1Wb00RiPJrRXP";

const constants = { baseUrl, endPointUrl, STRIPE_PK };

export default constants;
